import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/register-sw";
import { showUpdatePrompt } from "@/lib/update-prompt";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// After render, so the update notice has a Toaster to appear in. Does nothing
// on plain http or inside the desktop app; see lib/register-sw.js for why.
registerServiceWorker(showUpdatePrompt);
